import { Route } from '/@/modules/core/app/constants/api.constants';
import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { ConnectedFinancialInstitution } from '/@/modules/financialaccount/models/ConnectedFinancialInstitution';

export class FinancialInstitutionResource extends BaseResource {
  getConnectedInstitutions() {
    return this.getData(
      Route.FINANCIAL_ACCOUNTS_CONNECTED_INSTITUTIONS,
      ConnectedFinancialInstitution
    );
  }
}
